import styled from "styled-components";

export const LauncherButton = styled.button`
  align-items: center;
  background: var(--WHITE, #fff);
  border: 1px solid var(--LIGHT-GREY, #e4e6ef);
  border-radius: 999px;
  bottom: 24px;
  box-shadow: 0 4px 16px rgba(14, 14, 44, 0.12);
  cursor: pointer;
  display: flex;
  gap: 10px;
  padding: 8px 16px 8px 8px;
  position: fixed;
  right: 24px;
  z-index: 1040;

  &:hover {
    border-color: var(--BLUE, #2060ea);
  }
`;

export const LauncherLabel = styled.span`
  color: var(--DARK-GREY, #0e0e2c);
  font-size: 13px;
  font-weight: 600;
  max-width: 180px;
  text-align: left;
`;

export const LauncherRestoreButton = styled.button`
  background: var(--WHITE, #fff);
  border: 1px dashed var(--LIGHT-GREY, #e4e6ef);
  border-radius: 999px;
  bottom: 24px;
  box-shadow: 0 2px 8px rgba(14, 14, 44, 0.08);
  color: var(--BLUE, #2060ea);
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 16px;
  position: fixed;
  right: 24px;
  z-index: 1040;

  &:hover {
    border-color: var(--BLUE, #2060ea);
  }
`;

export const DrawerBody = styled.div`
  padding: 16px 20px 32px;
`;

export const SectionBlock = styled.section`
  & + & {
    margin-top: 20px;
  }
`;

export const SectionTitle = styled.h3`
  color: var(--DARK-GREY, #0e0e2c);
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 10px;
`;

export const StepRowWrap = styled.div`
  border: 1px solid var(--LIGHT-GREY, #e4e6ef);
  border-radius: 8px;
  padding: 12px 14px;

  & + & {
    margin-top: 8px;
  }
`;

export const StepHeader = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 10px;
`;

export const StepTitle = styled.div`
  color: var(--DARK-GREY, #0e0e2c);
  flex: 1;
  font-size: 13px;
  font-weight: 600;
`;

export const StepDescription = styled.p`
  color: var(--GREY, #5e6278);
  font-size: 12px;
  line-height: 1.45;
  margin: 6px 0 0 28px;
`;

export const StepDetail = styled.p`
  color: var(--BLUE, #2060ea);
  font-size: 12px;
  margin: 4px 0 0 28px;
`;

export const StepActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0 28px;
`;
